// utils/dateLimits.js
import dayjs from "../utils/dayjsConfig";

// export const makeDisabledDatePastNDays = (n = 2) => (current) => {
//     console.log("System local now:", dayjs().format());
//     console.log("US/Central now:", dayjs().tz("America/Chicago").format());
//   if (!current) return false;
//   const cutoffDay = dayjs().subtract(n, "day").startOf("day");
//   return current.isSame(cutoffDay, "day") || current.isAfter(cutoffDay, "day");
// };

// export const disabledDatePast2Days = makeDisabledDatePastNDays(2);

// // 👇 add default export
// export default disabledDatePast2Days;

const TZ = "America/Chicago"; // US Central

export const makeDisabledDatePastNDays =
  (n = 2) =>
  (current) => {
    if (!current) return false;

    // Force current into Central timezone
    const currentCentral = current.tz(TZ).startOf("day");

    // Cutoff in Central timezone
    const cutoffCentral = dayjs().tz(TZ).subtract(n, "day").startOf("day");

    // Disable today, last n days, and any future date
    return (
      currentCentral.isSame(cutoffCentral, "day") ||
      currentCentral.isAfter(cutoffCentral, "day")
    );
  };

export const disabledDatePast2Days = makeDisabledDatePastNDays(2);

export const formatDateToYYYYMMDD = (dateString) => {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export default disabledDatePast2Days;
